import React from 'react';
import { Card } from 'react-bootstrap';

// PlanOption Component: Represents a pricing plan (monthly or yearly)
const PlanOption = ({ planName, price, billingCycle, selectedPlan, setSelectedPlan, description }) => {
  return (
    <Card
      className={`plan-option ${selectedPlan === planName ? 'selected' : ''}`}
      onClick={() => setSelectedPlan(planName)}
      style={{
        border: selectedPlan === planName ? '2px solid green' : '1px solid gray',
        cursor: 'pointer',
        marginBottom: '20px',
      }}
    >
      <Card.Body>
        <Card.Title>{planName.charAt(0).toUpperCase() + planName.slice(1)} Plan</Card.Title>
        <h4>{price}</h4>
        <p>{billingCycle}</p>
        <p>{description}</p>
      </Card.Body>
    </Card>
  );
};

export default PlanOption;
